import { stringifyGraph } from '@/clients/http'
import { OfferModel } from '@/http/models/Offer'
import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'
import { OfferHttpParams, OfferModel as OfferModelType } from '@/types'

export interface CampaignListFilters {
  search?: string
  status?: OfferModelType.Status | null
}

export interface CampaignListForm extends UseFetchListForm<
  CampaignListFilters,
  OfferModelType.Offer
> {}

export const campaignInitialFilters: CampaignListFilters = {
  search: '',
  status: null,
}

export const useFetchCampaigns = ({ sort }: { sort?: string | null }) => {
  return useFetchList<
    CampaignListFilters,
    OfferModelType.Offer,
    {},
    any,
    typeof OfferModel.getList
  >({
    pageSize: 12,
    initialFilters: campaignInitialFilters,
    fetchFunction: OfferModel.getList,
    sort,
    register: true,
    buildQueryParams: (filters): Partial<OfferHttpParams.GetList['query']> => ({
      is_campaign: true,
      search: filters.search || undefined,
      status: filters.status || undefined,
      graph_enc: stringifyGraph({ '*': true }),
    }),
    buildParams: () => ({}),
  })
}
